import * as React from "react";

import { UitkLayoutGrid, UitkLayoutGridItem, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { UitkLayoutFlex, UitkLayoutFlexItem, UitkLayoutFlexProps } from "uitk-react-layout-flex";
import { UitkSpacing, UitkSpacingProps } from "uitk-react-spacing";
import { SpacingSize } from "src/components/utility/FlexAttributesUtil";

export type ScrimCardTransparentProps = {
  id: string;
  dataTestId?: string;
  titleSlot?: React.ReactNode | React.ReactNode[];
  subtitleSlot?: React.ReactNode | React.ReactNode[];
  footerSlot?: React.ReactNode | React.ReactNode[];
  marginClass?: string;
  className: string;
  spacing?: UitkSpacingProps;
  domRef?: React.RefObject<HTMLElement> | null;
  justifyContent?: UitkLayoutFlexProps["justifyContent"];
  mainGridColumns?: UitkLayoutConditionalGridColumnRow;
  padding?: string;
};

export const ScrimCardTransparent: React.FC<ScrimCardTransparentProps> = ({
  id,
  dataTestId = "scrim-card-transparent",
  className,
  titleSlot,
  subtitleSlot = null,
  footerSlot = null,
  spacing = {},
  domRef = null,
  justifyContent = "space-between",
  mainGridColumns = { small: 1, medium: 2 },
  padding,
}) => {
  const subheadingCols: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 1 };
  const hasNoPadding = padding === SpacingSize.NONE;
  const blockendSpacing = hasNoPadding ? "unset" : "six";

  return (
    <UitkSpacing padding={{ blockend: blockendSpacing }}>
      <section data-testid={dataTestId} id={id} ref={domRef} className={className}>
        <UitkSpacing {...spacing}>
          <UitkLayoutFlex direction="column" justifyContent={justifyContent} style={{ height: "inherit" }}>
            <UitkLayoutFlexItem>
              <div>
                {titleSlot && titleSlot}
                {subtitleSlot && (
                  <UitkSpacing padding={{ blockstart: "three" }}>
                    <UitkLayoutGrid columns={mainGridColumns}>
                      <UitkLayoutGridItem colSpan={subheadingCols}>{subtitleSlot}</UitkLayoutGridItem>
                    </UitkLayoutGrid>
                  </UitkSpacing>
                )}
              </div>
            </UitkLayoutFlexItem>

            {footerSlot && (
              <UitkLayoutFlexItem>
                <div>{footerSlot}</div>
              </UitkLayoutFlexItem>
            )}
          </UitkLayoutFlex>
        </UitkSpacing>
      </section>
    </UitkSpacing>
  );
};
